const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const UserReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_USER_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_USER_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_USER_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default UserReducer;